import { React, useState, useEffect } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { ButtonDropdown, DropdownMenu, DropdownToggle } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import PropTypes from "prop-types";
import ProductCards from "./productCards";
import PartnerDetailsCard from "./partnerDetailsCard";

const ProductTabs = ({
  bundleCount,
  courseId,
  multiContentDescriptionLong,
  partner
}) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 680);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedText, handleClick] = useState("Courses Included");

  useEffect(() => {
    window.addEventListener(
      "resize",
      () => {
        const ismobile = window.innerWidth < 680;
        if (ismobile !== isMobile) setIsMobile(ismobile);
      },
      false
    );
  }, [isMobile]);

  const toggle = () => setDropdownOpen(prevState => !prevState);

  function handleDropdownClick(event) {
    const e = event.target.innerText;
    handleClick(e);
    toggle();
  }

  return (
    <>
      <Tabs>
        {isMobile ? (
          <ButtonDropdown
            className="dropdown"
            isOpen={dropdownOpen}
            toggle={toggle}
          >
            <DropdownToggle
              tag="span"
              data-toggle="dropdown"
              aria-expanded={dropdownOpen}
            >
              {selectedText}
              <FontAwesomeIcon icon={faAngleDown} />
            </DropdownToggle>
            <TabList>
              <DropdownMenu>
                <Tab
                  data-toggle="tab"
                  onClick={e => handleDropdownClick(e)}
                  className="dropdown-item"
                >
                  Courses Included
                </Tab>
                <Tab
                  data-toggle="tab"
                  onClick={e => handleDropdownClick(e)}
                  className="dropdown-item"
                >
                  Product Details
                </Tab>
              </DropdownMenu>
            </TabList>
          </ButtonDropdown>
        ) : (
          <TabList>
            <Tab xpath="react-tab__coursesIncluded">Courses Included</Tab>
            <Tab xpath="react-tab__productDetails">Product Details</Tab>
          </TabList>
        )}
        <TabPanel>
          <ProductCards bundleCount={bundleCount} courseId={courseId} />
        </TabPanel>
        <TabPanel>
          <h4 className="title">About this course</h4>
          <div className="row">
            <div className="col-sm-9 courseDescription">
              {multiContentDescriptionLong.replace(/(<([^>]+)>)/gi, "")}
            </div>
            <div className="col-sm-3">
              <PartnerDetailsCard partner={partner} />
            </div>
          </div>
        </TabPanel>
      </Tabs>
    </>
  );
};

ProductTabs.propTypes = {
  bundleCount: PropTypes.number,
  courseId: PropTypes.number,
  multiContentDescriptionLong: PropTypes.string,
  partner: PropTypes.string
};

ProductTabs.defaultProps = {
  bundleCount: false,
  courseId: null,
  multiContentDescriptionLong: null,
  partner: null
};

export default ProductTabs;
